import * as React from "react";
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { NotFound } from "./pages/NotFound.tsx";
import { LoginPage } from "./pages/LoginPage.tsx";
import { AppLoaderPage } from "./pages/AppLoaderPage.tsx";
import AppContent from "./AppContent.tsx";

import axios from 'axios';

interface AppState  {
    productVersion: string,
    environment: string,
    region: string,
    isReportingUser: boolean,
    userName: string,
    userEmail: string,
};

function App() {
    const [isLoading, setIsLoading] = useState(true);
    const [appState, setAppState] = useState<AppState>();

    const [isAuthenticated, setIsAuthenticated] = useState(false);   

    useEffect(() => {
        setIsLoading(true);
        axios.get("api/Application/Get")
            .then((response) => {
                setTimeout(() => {
                    setIsAuthenticated(response.data.isAuthenticated);                 
                    setAppState(response.data);                    
                    setIsLoading(false);
                }, 3000);
            })
            .catch((err) => {
                setIsAuthenticated(false);
                setIsLoading(false);
                const errorMessage = typeof err.response.data === 'string' ? err.response.data : err.response.data.title;
                console.log(errorMessage);
                setIsLoading(false);
            });
    }, []);    

    if (isLoading) {
        return (
            <AppLoaderPage />
        );
    }

    if (!isAuthenticated) {
        return (
            <LoginPage />
        );
    } 

    if (isAuthenticated) {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path="/index" component={(props) => <AppContent {...props} appVersion={appState.productVersion} environment={appState.environment} region={appState.region} isReportingUser={appState.isReportingUser} userName={appState.userName} userEmail={appState.userEmail} />}/>
                    <Route component={NotFound} />
                </Switch>
            </BrowserRouter>
        );
    } 
}

export default App;